var mp = mp || {};

// Form validation
//----------------------------------------------------------
mp.formContact = function() {
    var $form = $('#form-contact');
        $submitBtn = $form.find('button.btn');

    if (!$form.length) {
        return;
    }

    $form.validate({
        rules: {
            "first_name": {
                required: true,
                minlength: 2
            },
            "last_name": {
                required: true,
                minlength: 2
            },
            "email": {
                required: true,
                email: true
            },
            "phone": {
                required: true,
                minlength: 6
            },
            "message": {
                required: true,
                minlength: 10
            },
            "consent": {
                required: true,
                minlength: 1
            },
        },
        errorPlacement: function(error, element) {
            //element.addClass("test");
        },

        invalidHandler: function(event, validator) {
            // $submitBtn.toggleClass('disabled');
        },

        highlight: function(element, errorClass, validClass) {
            $(element).addClass(errorClass);
            $(element).parents('.form__group').addClass(errorClass);
        },

        unhighlight: function(element, errorClass, validClass) {
            $(element).removeClass(errorClass);
            $(element).parents('.form__group').removeClass(errorClass);
        },

        submitHandler: function(form) {
            $submitBtn.attr('disabled','disabled');

            var $formData = new FormData(form);
            var $sitekey = $form.find('input[name=recaptcha_site_key]').val();

            grecaptcha.ready(function() {
                grecaptcha.execute($sitekey).then(function(token) {
                    $formData.append('token', token);

                    $.ajax({
                        url: form.action,
                        type: form.method,
                        data: $formData,
                        cache: false,
                        contentType: false,
                        processData: false,
                        success: function(response) {
                            $submitBtn.removeAttr('disabled');
                            response = jQuery.parseJSON(response);

                            if (response.status=="success") {
                                form.reset();
                                $('select').selectric('refresh');
                                
                                alert(response.msg);
                            } else {
                                alert(response.msg);
                            }
                        }            
                    });
                });
            });
        }

    });
};



$(document).ready(function (){
    mp.formContact();
});